exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".xsell .xsell-product {\n  padding: 2em 0 !important;\n}\n.xsell .xsell-product:not(:last-child) {\n  border-bottom: 1px solid #ebebeb;\n}\n", ""]);

// exports
